import { ROUTE_MODULE } from '@/store/modules/routeModule';
import {
  LOCAL_STORAGE_KEY_DARK_THEME_ENABLED,
  LOCAL_STORAGE_KEY_LANGUAGE,
  LOCAL_STORAGE_KEY_SCROLL_OFF_NAVBAR,
} from './constants';

export default {
  initLocalPreference({ commit, state }) {
    const languagePreference =
      window.localStorage.getItem(LOCAL_STORAGE_KEY_LANGUAGE) || state.language;
    commit('SET_LANGUAGE', languagePreference);
    const darkThemeEnabledPreference = JSON.parse(
      window.localStorage.getItem(LOCAL_STORAGE_KEY_DARK_THEME_ENABLED) ||
        `${state.darkThemeEnabled}`
    );
    commit('SET_DARK_THEME', darkThemeEnabledPreference);
    const scrollOffNavbarEnabledPreference = JSON.parse(
      window.localStorage.getItem(LOCAL_STORAGE_KEY_SCROLL_OFF_NAVBAR) ||
        `${state.scrollOffNavbarEnabled}`
    );
    commit('SET_SCROLL_OFF_NAVBAR', scrollOffNavbarEnabledPreference);
  },
  toggleSideBar({ commit, state }) {
    commit('SET_SIDEBAR_OPENED', !state.sidebar.opened);
  },
  toggleRightSideBar({ commit, state }) {
    commit('SET_RIGHT_SIDEBAR_OPENED', !state.sidebar.right.opened);
  },
  setRightSideBarOpened({ commit }, opened) {
    commit('SET_RIGHT_SIDEBAR_OPENED', opened);
  },
  setSideBarOpened({ commit }, opened) {
    commit('SET_SIDEBAR_OPENED', opened);
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token);
  },
  setAuthenticated({ commit }, authenticated) {
    commit('SET_AUTHENTICATED', authenticated);
  },
  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading);
  },
  addDelayedModule({ commit }, module) {
    commit('ADD_DELAYED_MODULE', module);
  },
  removeDelayedModule({ commit }, module) {
    commit('REMOVE_DELAYED_MODULE', module);
  },
  toggleDarkTheme({ commit, state }) {
    commit('SET_DARK_THEME', !state.darkThemeEnabled);
  },
  toggleScrollOffNavbar({ commit, state }) {
    commit('SET_SCROLL_OFF_NAVBAR', !state.scrollOffNavbarEnabled);
  },
  setModalClosed({ dispatch, rootGetters }) {
    if (rootGetters['boilerplate/isModalOpen']) {
      dispatch('setModalOpened', { component: null });
    }
  },
  setModalOpened({ commit, getters, rootState }, params) {
    const tab = params ? params.tab : null;
    commit('SET_MODAL_INITIAL_TAB', tab);
    const { component } = params;
    const routeName = rootState[ROUTE_MODULE].name;
    let routes = Array.from(getters.isOpen);

    routes = routes.filter((item) => item.route !== routeName);
    if (component) {
      routes.push({ route: routeName, component });
    }
    commit('SET_MODAL_OPENED_IN_ROUTE', routes);
  },
  toggleModalFullscreen({ commit, getters }) {
    commit('SET_MODAL_FULLSCREEN', !getters.isModalFullscreen);
  },
};
